export class SessionStats {
}
//# sourceMappingURL=isession-manager.js.map